import { type Namespace } from 'i18next';

export const filtersI18n = ['filters'] satisfies Namespace;
